import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function Tooltip(props){
    const [ isActive, setIsActive ] = useState(false);
    const sizeString = `${props.size}px`;
    const viewBox = `0 0 ${props.size} ${props.size}`;
    const radius = (Math.floor( Number(props.size - props.strokeWidth)/2 ) ).toString();
    const color = props.color || "#000000";
    const strokeWidth = props.strokeWidth.toString() || "2";
    const textSize = `${Math.floor(0.7 * props.size)}px`;
    const tip = props.tip;
    const tipStyles = props.tipStyles ? { ...props.tipStyles} : 
    {
        position: 'absolute',
        bottom: '0',
        left: props.size.toString()+'px',
        backgroundColor: '#ffffff',
        fontSize: props.fontSize+'px',
        zIndex: '5',
        border: '1px solid gray',
        borderRadius: '3px',
        padding: '3px',
        boxShadow: '1px 1px 2px 1px rgba(0, 0, 0, 0.3)',
        textAlign: 'left'
    };
    tipStyles['display'] = isActive ? 'block' : 'none';
    let alignment;
    switch( props.alignment ){
        case 'left':
            alignment = 'flex-start';
        break;
        case 'right':
            alignment = 'flex-end';
        break;
        case 'center':
            alignment = 'center';
        break;
        default:
            alignment = 'flex-start';
    }

    return(
        <>
        {/* <div style={{position: 'relative', height: sizeString, width: '100%', textAlign: 'left', display: 'flex', justifyContent: alignment, lineHeight: '1'}} > */}
            <div
                style={{width: sizeString, height: sizeString, cursor: 'default'}}
                onMouseEnter={ () => setIsActive(true) }
                onMouseLeave={ () => setIsActive(false) }
            >
                <svg 
                    version="1.1"
                    className="tooltip_svg"
                    xmlns="http://www.w3.org/2000/svg"
                    width={sizeString}
                    height={sizeString}
                    viewBox={viewBox}
                >
                    <circle cx="50%" cy="50%" r={ radius } stroke={ color } strokeWidth={ strokeWidth } fill="none" />
                    <text
                        x="50%"
                        y="49%"
                        textAnchor="middle"
                        stroke={ color }
                        strokeWidth={ (props.strokeWidth/2).toString() }
                        fontSize={ textSize }
                        dominantBaseline="central"
                    >i</text>
                </svg>
            </div>
            {
                tip &&
                <span style={tipStyles}>{tip}</span>
            }
            </>
        //</div>
    );
}

Tooltip.propTypes = {
	size: PropTypes.number.isRequired,
    color: PropTypes.string,
    strokeWidth: PropTypes.number,
    tip: PropTypes.string
};